import { render, staticRenderFns } from "./transactionTable.vue?vue&type=template&id=90db7078"
import script from "./transactionTable.vue?vue&type=script&lang=js"
export * from "./transactionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/Projects/PECOS/pecos_ivm_apiserver-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90db7078')) {
      api.createRecord('90db7078', component.options)
    } else {
      api.reload('90db7078', component.options)
    }
    module.hot.accept("./transactionTable.vue?vue&type=template&id=90db7078", function () {
      api.rerender('90db7078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/transactionTable.vue"
export default component.exports